var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchivoAzul(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "power_settings_new_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.703,
    height: 23.703,
    viewBox: "0 0 23.703 23.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_923",
    "data-name": "Trazado 923",
    d: "M0,0H23.7V23.7H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "archive_FILL0_wght300_GRAD0_opsz40",
    d: "M141.183-816.243v10.772a.282.282,0,0,0,.081.208.282.282,0,0,0,.208.081h13.056a.282.282,0,0,0,.208-.081.282.282,0,0,0,.081-.208v-10.772ZM141.546-804a1.479,1.479,0,0,1-1.075-.47,1.479,1.479,0,0,1-.47-1.075v-11.271a1.491,1.491,0,0,1,.079-.483,1.4,1.4,0,0,1,.238-.43l1.347-1.713a1.363,1.363,0,0,1,.5-.41,1.475,1.475,0,0,1,.651-.149h10.335a1.5,1.5,0,0,1,.655.149,1.355,1.355,0,0,1,.508.41l1.365,1.731a1.389,1.389,0,0,1,.238.435,1.531,1.531,0,0,1,.079.488v11.243a1.479,1.479,0,0,1-.47,1.075,1.479,1.479,0,0,1-1.075.47Zm.015-13.426h12.856l-1.054-1.292a.359.359,0,0,0-.1-.072.289.289,0,0,0-.122-.027h-10.3a.31.31,0,0,0-.125.027.281.281,0,0,0-.1.072Z",
    transform: "translate(-136.15 824.35)",
    fill: "#00bdd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivoAzul);
export default __webpack_public_path__ + "static/media/archivo_azul.b7f478eca4ad45d261985dc2031e2e4d.svg";
export { ForwardRef as ReactComponent };